import { useEffect, useMemo, useState } from "react";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useNavigate, useParams } from 'react-router-dom';
import { DecodeFormBase64 } from '../../../helpers/tools';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { CustomButton } from "../../../components/customButton/CustomButton";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";


export default function TerminoUsers() {

  const navigate = useNavigate();
  let params = useParams();

  let terminoId = "";

  if (!!params?.terminoId) {
    try {
      terminoId = parseInt(DecodeFormBase64(params.terminoId), 10);
    } catch {
    }
  }

  const [rows, setRows] = useState([]);

  // redirecciono a la grilla en caso de no recibir un parámetro numérico
  useEffect(() => {
    if (isNaN(terminoId)) {
      navigate('/termadmin');
    }
  }, []);

  const handleVolver = () => {
    navigate('/termadmin');
  };

  const initialColumns = [
    { field: 'apellido', headerName: 'Apellido', minWidth: 200, flex: 0.7, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell' },
    { field: 'nombre', headerName: 'Nombre', minWidth: 200, flex: 0.7, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell' },
    { field: 'usuario', headerName: 'Usuario', minWidth: 100, flex: 0.5, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell' },
    { field: 'fecha', headerName: 'Fecha', type: 'date', time: true, valueGetter: (value) => value && new Date(value), minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell' }
  ];

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), []);

  const QTermino = gql`
        query QTerminoUsuariosFirmantes($idTermino: Int!) {
            terminoUsuariosFirmantes(
                idTermino: $idTermino
            ) 
            {
                success,
                error,
                valorEsperado {
                    idTermino,
                    version,
                    vigenciaDesde,
                    vigenciaHasta,
                    idUsuario,
                    fecha,
                    apellido,
                    nombre,
                    usuario
                }
            }
        }`;

  const { loading, data } = useQuery(QTermino, { fetchPolicy: 'no-cache', variables: { idTermino: terminoId } });

  useEffect(() => {
    if (!data) return;
    console.log("retorno!");
    setRows(data.terminoUsuariosFirmantes.valorEsperado);
  }, [data]);


  return (
    <>
      <div className='botonera-superior' style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <CustomButton
          onClick={handleVolver}
          size='small'
          title="Volver a la grilla de Términos y Condiciones"
          variant='contained'>
          Volver
        </CustomButton>
      </div>
      <br />
      <DataGridGenerico
        columns={columns}
        fileNameExport='UsuariosTerminos'
        loading={loading}
        rows={rows} />
    </>);
};